import SideMenu from "../../../ui/SideMenu";
import { useDispatch, useSelector } from "react-redux";
import { closeSideMenu, openSideMenu } from "../../../redux/ui/uiSlice";
import styles from "../../../styles/Components/mini-app/shared/MiniCreateBot.module.css";
import React, { useState } from "react";
import BotNameSettings from "../../../shared/create-bot/settings-steps/BotNameSettings";
import SelectExchangeSettings from "../../../shared/create-bot/settings-steps/SelectExchangeSettings";
import { riskOptions } from "../../../utility/data";
import { Button, Select, Slider, Tooltip } from "antd";
import { FaBalanceScale, FaBitcoin, FaSmile } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaChevronDown } from "react-icons/fa6";
import AIAssistantModeSettings from "../../../shared/create-bot/settings-steps/AIAssistantModeSettings";
import { createBot } from "../../../redux/bot/actions";
import useUserData from "../../../hooks/useUserData";
const { Option } = Select;

const STRATEGIES = [
  {
    label: "Time-based AI-assisted (Recommended)",
    value: "Time-based AI-assisted",
  },
  { label: "Trend Following", value: "Trend Following" },
  { label: "Reversal Strategies", value: "Reversal Strategies" },
  { label: "Volatility Management", value: "Volatility Management" },
  { label: "All Day Trading", value: "All Day Trading" },
  { label: "Momentum Strategies", value: "Momentum Strategies" },
  { label: "Breakout Strategies", value: "Breakout Strategies" },
];

function MiniCreateBot({ title, btnClassName }) {
  const {
    botState: { createBotLoading },
  } = useSelector((state) => state);

  const [botConfig, setBotConfig] = useState({
    bot_name: "CryptoCrispy bot1",
    selected_exchange: "cryptocrispy",
    trade_in_virtual_portfolio: "False",
    risk_tolerance: "3",
    target_return_percentage: "10",
    crypto_allocation_strategy: "balanced",
    signal_source: "AI_Assistant",
    ai_assistant_mode: "default",
    selected_trading_strategies: ["Time-based AI-assisted"],
    number_of_coins: "3",
  });

  const { username, email } = useUserData();
  const dispatch = useDispatch();

  const openMenu = () => {
    dispatch(openSideMenu("mini-create-bot", "mini-create-bot"));
  };

  const changeBotConfig = (key, value) => {
    if (key === "selected_trading_strategies") {
      setBotConfig((prevState) => {
        return {
          ...prevState,
          [key]: value,
        };
      });
      return;
    }

    setBotConfig((prevState) => {
      return {
        ...prevState,
        [key]: value,
      };
    });
  };

  const submitHandler = async () => {
    if (createBotLoading) return;

    await dispatch(createBot(username, email, botConfig)).then(() => {
      dispatch(closeSideMenu());
      setBotConfig({
        bot_name: "CryptoCrispy bot1",
        selected_exchange: "cryptocrispy",
        trade_in_virtual_portfolio: "False",
        risk_tolerance: "3",
        target_return_percentage: "10",
        crypto_allocation_strategy: "balanced",
        signal_source: "AI_Assistant",
        ai_assistant_mode: "default",
        selected_trading_strategies: ["Time-based AI-assisted"],
        number_of_coins: "3",
      });
    });
  };

  return (
    <>
      <span className={btnClassName} onClick={openMenu}>
        {title}
      </span>

      <SideMenu
        title="Create New Bot"
        scope="mini-create-bot"
        className={styles.container}
      >
        <div className={styles.form}>
          <BotNameSettings
            name={botConfig?.bot_name}
            changeBotConfig={changeBotConfig}
            className={styles.botName}
          />
          <div className={styles.exchange}>
            <SelectExchangeSettings
              selectedExchange={botConfig?.selected_exchange}
              changeBotConfig={changeBotConfig}
            />
          </div>

          <div className={styles.risk}>
            <div className={styles.header}>
              <span>Risk Tolerance</span>
              <span>{riskOptions?.[botConfig?.risk_tolerance]}</span>
            </div>
            <Slider
              min={1}
              max={5}
              value={+botConfig?.risk_tolerance + 1}
              onChange={(e) => {
                changeBotConfig("risk_tolerance", `${e - 1}`);
              }}
              tooltip={{
                color: "#0c4cfc",
              }}
            />
          </div>

          <div className={styles.risk}>
            <div className={styles.header}>
              <span>Set Target Returns</span>
              <span>{botConfig?.target_return_percentage}%</span>
            </div>
            <Slider
              min={1}
              max={100}
              value={+botConfig?.target_return_percentage}
              onChange={(e) => {
                changeBotConfig("target_return_percentage", `${e}`);
              }}
              tooltip={{
                open: false,
              }}
            />
          </div>

          <div className={`${styles.risk} ${styles.exchange}`}>
            <div className={styles.header}>
              <span>Crypto Allocation</span>
            </div>
            <Select
              value={botConfig?.crypto_allocation_strategy}
              className={styles.allocationSelect}
              style={{ width: "100%" }}
              placeholder="Select allocation strategy"
              onChange={(value) =>
                changeBotConfig("crypto_allocation_strategy", value)
              }
              optionLabelProp="label"
              suffixIcon={<FaChevronDown color="black" />}
            >
              <Option value="balanced" label="Balanced">
                <Tooltip
                  title="50% Bitcoin, 30% Ethereum, 20% Other Altcoins"
                  color="#0c4cfc"
                >
                  <div className={styles.selectOption}>
                    <FaBalanceScale />
                    <span>Balanced</span>
                    <IoInformationCircleOutline color="#0c4cfc" size={16} />
                  </div>
                </Tooltip>
              </Option>

              <Option value="bitcoin_dominant" label="Bitcoin Dominant">
                <Tooltip
                  title="70% Bitcoin, 20% Ethereum, 10% Other Altcoins"
                  color="#0c4cfc"
                >
                  <div className={styles.selectOption}>
                    <FaBitcoin />
                    <span>Bitcoin Dominant</span>
                    <IoInformationCircleOutline color="#0c4cfc" size={16} />
                  </div>
                </Tooltip>
              </Option>

              <Option value="altcoin_enthusiast" label="Altcoin Enthusiast">
                <Tooltip
                  title="30% Bitcoin, 40% Ethereum, 30% Other Altcoins"
                  color="#0c4cfc"
                >
                  <div className={styles.selectOption}>
                    <FaSmile />
                    <span>Altcoin Enthusiast</span>
                    <IoInformationCircleOutline color="#0c4cfc" size={16} />
                  </div>
                </Tooltip>
              </Option>
            </Select>
          </div>

          <div className={`${styles.risk} ${styles.exchange}`}>
            <div className={styles.header}>
              <span>Signal Source</span>
            </div>
            <Select
              value={botConfig?.signal_source}
              className={styles.allocationSelect}
              style={{ width: "100%" }}
              placeholder="Select allocation strategy"
              onChange={(value) => changeBotConfig("signal_source", value)}
              optionLabelProp="label"
              suffixIcon={<FaChevronDown color="black" />}
            >
              <Option value="AI_Assistant" label="AI Assistant">
                <div className={styles.selectOption}>
                  <span>AI Assistant</span>
                  <Tooltip title="It covers top 20 crypto coins" color="blue">
                    <IoInformationCircleOutline color="#0c4cfc" size={16} />
                  </Tooltip>
                </div>
              </Option>

              <Option value="VIP_channel" label="VIP signals">
                <div className={styles.selectOption}>
                  <span>VIP signals</span>
                  <Tooltip
                    title="It covers all coins but it is recommended to adventurous users"
                    color="blue"
                  >
                    <IoInformationCircleOutline color="#0c4cfc" size={16} />
                  </Tooltip>
                </div>
              </Option>
            </Select>
          </div>

          {botConfig.signal_source === "AI_Assistant" && (
            <div className={styles.aiMode}>
              <div className={styles.header}>
                <span>AI Assistant Mode</span>
              </div>
              <AIAssistantModeSettings
                aiMode={botConfig?.ai_assistant_mode}
                changeConfig={changeBotConfig}
              />
            </div>
          )}

          <div className={`${styles.risk} ${styles.exchange}`}>
            <div className={styles.header}>
              <span>Crypto Trading Strategies</span>
            </div>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select trading strategies"
              value={botConfig?.selected_trading_strategies}
              onChange={(values) =>
                changeBotConfig("selected_trading_strategies", values)
              }
              style={{ width: "100%" }}
              optionFilterProp="label"
              suffixIcon={<FaChevronDown color="black" />}
              status={
                botConfig?.selected_trading_strategies?.length === 0
                  ? "error"
                  : ""
              }
            >
              {STRATEGIES.map((item) => (
                <Option key={item.value} value={item.value} label={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </div>

          <div className={styles.risk}>
            <div className={styles.header}>
              <span>Number Of Coins</span>
              <span>{botConfig?.number_of_coins}</span>
            </div>
            <Slider
              min={1}
              max={30}
              value={+botConfig?.number_of_coins}
              onChange={(e) => {
                changeBotConfig("number_of_coins", `${e}`);
              }}
              tooltip={{
                open: false,
              }}
            />
          </div>

          <Button
            className={styles.submitBtn}
            loading={createBotLoading}
            disabled={
              botConfig?.selected_trading_strategies?.length === 0 ||
              botConfig?.bot_name?.length === 0
            }
            onClick={submitHandler}
          >
            Confirm
          </Button>
        </div>
      </SideMenu>
    </>
  );
}

export default MiniCreateBot;
